import {Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {MessagingService} from '../../../services/messaging.service';
import {FeeScheduleService} from '../services/fee-schedule.service';
import {MatDialog} from '@angular/material/dialog';
import {FeeScheduleItemDataModel} from '../../../models/fee-schedule/fee-schedule-item-data.model';
import {FeeScheduleItemsHModel, FeeScheduleItemsModel} from '../models/fee-schedule-items.model';
import {DataFeeScheduleItemFee4FeesJoinedModel} from '../models/data-fee-scheduleItem-fee4fees-joined.model';
import {dataFeeScheduleDoctor} from '../../ar/_models/ar.models';

import DevExpress from 'devextreme';
import EnterKeyDirection = DevExpress.common.grids.EnterKeyDirection;
import EnterKeyAction = DevExpress.common.grids.EnterKeyAction;
import {FeeItemCategoryIdEnum} from '../../../models/enum/fee-item-category-id.enum';
import {StaticDataService} from '../../../services/static-data.service';
import {enumValidValueItem} from '../../tdo-shared/tooth-picker/tooth-picker.models';
import {FeeScheduleDocFeeModel} from '../models/fee-schedule-doc-fee.model';
import {ToastrService} from 'ngx-toastr';
import {FeeAdjustmentsComponent} from '../fee-adjustments/fee-adjustments.component';
import {catchError} from 'rxjs/operators';
import { DxDataGridComponent  } from 'devextreme-angular';
import {FeeScheduleImportCvsComponent} from '../fee-schedule-import-cvs/fee-schedule-import-cvs.component';




@Component({
    selector: 'app-fee-schedule-edit-items',
    templateUrl: './fee-schedule-edit-items.component.html',
    styleUrls: ['./fee-schedule-edit-items.component.scss']
})
export class FeeScheduleEditItemsComponent implements OnInit, OnDestroy {
    @Input() feeSchedule: FeeScheduleDataModel;
    @Input() selectedDocFeeScheduleID: string;

    @ViewChild(DxDataGridComponent, { static: false }) gridContainerTree: DxDataGridComponent;



    isLoading: boolean = false;
    listOfFees_Hierarchal: FeeScheduleItemsHModel[] = [];
    listOfFees_TableTreeFiltered: FeeScheduleItemsModel[] = [];
    listOfFees_Table: FeeScheduleItemsModel[] = [];
    messagingSubscription: any;
    feeScheduleDoctor: dataFeeScheduleDoctor;
    enumfeeItemCategories: enumValidValueItem[];

    editOnkeyPress = true;
    enterKeyAction: EnterKeyAction = 'moveFocus';
    enterKeyDirection: EnterKeyDirection = 'column';
    currentFeeView: string = 'grid';
    treeItemSelected: any;
    startEditAction: string = 'click';
    selectTextOnEditStart: boolean = true;
    firstRow_DocFeeScheduleItemID: string = '';




    feeViews: any[] = [

        {
            icon: 'detailslayout',
            name: 'grid',
            hint: 'Table view',
        },
        {
            icon: 'hierarchy',
            name: 'tree',
            hint: 'Tree View',
        }
    ];




    constructor(
        private messagingService: MessagingService,
        private feeScheduleService: FeeScheduleService,
        private dialog: MatDialog,
        private staticDataService: StaticDataService,
        private toastr: ToastrService,
    ) { }


    ngOnInit() {

        this.messagingSubscription = this.messagingService.componentMessageCall.subscribe(
            response => {
                // console.log('message:' , response);

                if (response.event === 'SELECTED_FEE_SCHEDULE_CHANGES') {
                //


                }


                if (response.event === 'FEE_SCHEDULE_LOADING') {
                    this.isLoading = response.data.isLoading;
                }

                if (response.event === 'FEE_ITEM_SAVED') {
                    // console.log(1);
                    // this.startSaveCompleteTimer();
                }


                if (response.event === 'CLEAR_FEE_ITEMS') {
                    // z
                    // this.feeScheduleItems = [];
                    this.feeSchedule = null;
                    this.feeScheduleDoctor = null;
                    this.listOfFees_Table = [] ;
                    this.listOfFees_Hierarchal = [];
                }

                if (response.event === 'REFRESH_EXPLOSIONS') {
                    // this.dataExplosions = response.data.dataExplosions;
                    // this.switchToExplosions();
                }

                if (response.event === 'FEE_SCHEDULE_DOCTOR_CHANGED') {
                    // z
                    this.feeScheduleDoctor = response.data.feeScheduleDoctor;
                    this.feeSchedule = response.data.feeSchedule;

                    this.loadFeeScheduleData();


                }

                if (response.event === 'FEE_LIST_LOADING') {
                    this.isLoading = response.data.isLoading;
                }

                if (response.event === 'PUSH_NEW_FEE_SCHEDULE_ITEM_TO_FULL_LIST') {
                    // get new fee schedule item from response
                    // const newFeeScheduleItem: DataFeeScheduleItemFee4FeesJoinedModel = response.data.FeeScheduleItem;
                    // this.unGroupedItems.push(newFeeScheduleItem);
                }

                if (response.event === 'UPDATE_FEE_SCHEDULE_ITEM_IN_ALL_PLACES') {
                    // get new fee schedule item from response
                    const updatedFeeScheduleItem: DataFeeScheduleItemFee4FeesJoinedModel = response.data.FeeScheduleItem;

                }
            }
        );


        this.staticDataService.getAllValidValueItems().subscribe((data) => {
            this.enumfeeItemCategories = this.staticDataService.getValidValueItemsByItemIds([
                FeeItemCategoryIdEnum.Preventative,
                FeeItemCategoryIdEnum.Basic,
                FeeItemCategoryIdEnum.Other,
            ]);
        });


        if (this.selectedDocFeeScheduleID) {
            this.loadFeeScheduleData();
        }
    }

    ngOnDestroy(): void {

    }


    loadFeeScheduleData() {
        this.isLoading = true;

        if (this.gridContainerTree) {
            this.gridContainerTree.instance.clearFilter();
        }

        this.listOfFees_Hierarchal = [];
        this.listOfFees_Table = [];


        console.log('currentFeeView', this.currentFeeView);

        // console.log('this.feeScheduleDoctor  ', this.feeScheduleDoctor);

        this.feeScheduleService.getScheduleItemsWithFeesV2( this.feeScheduleDoctor.DocFeeScheduleID).subscribe({

            next: (res) => {
                this.listOfFees_Hierarchal = res;

                // console.log('h: ', this.listOfFees_Hierarchal);



                this.feeScheduleService.getScheduleItemsWithFeesTableV2(this.feeScheduleDoctor.DocFeeScheduleID).subscribe(r => {

                    this.listOfFees_Table = r;

                    this.firstRow_DocFeeScheduleItemID = this.listOfFees_Table[0].DocFeeScheduleItemID;

                    // console.log('t: ', this.listOfFees_Table);
                    this.isLoading = false;

                });
            },
            error: (err) => {

                console.log('error loading H: ', err);
                this.isLoading = false;
            }



        });




    }

    onFocusedCellChangingOnTable(e) {


    }

    millisecondsSinceMidnight(): number {
        const now = new Date();
        const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return now.getTime() - midnight.getTime();
    }
    onRowInsertedOnTable(e) {
        console.log('Inserting/Add Row: ', e);
        e.data.Code = 'Z1';
        e.data.Description = 'New Record';
        e.data.enumFeeItemCategoryId = '';
        e.data.Fee = 0.00;
        e.data.FeeScheduleID = this.listOfFees_Table[0].FeeScheduleID;

        e.data.DocFeeScheduleItemID = 'ID'  + this.millisecondsSinceMidnight().toString()  ;
        e.key = e.data.DocFeeScheduleItemID;
        e.data.FeeScheduleItemID = '';
        e.data.ParentFeeScheduleItemID = '';

    }


    onRowInsertedOnTreeTable(e) {
        e.data.Code = 'T1';
        e.data.Description = 'New Record';
        e.data.enumFeeItemCategoryId = '';
        e.data.Fee = 0.00;
        e.data.FeeScheduleID = this.listOfFees_Table[0].FeeScheduleID;
        e.data.DocFeeScheduleItemID = '';
        e.data.FeeScheduleItemID = '';
        e.data.ParentFeeScheduleItemID = this.treeItemSelected.FeeScheduleItemID;
    }

    overrideOnValueChangedTable(e) {
        console.log('value change: ', e);

        if (e.dataField === 'Description') {
            if (e.row?.isNewRow === true)  {
                e.editorOptions.disabled = false;
            }
            else {
                e.editorOptions.disabled = true;
            }
        }
        if (e.dataField === 'enumFeeItemCategoryId') {
            e.editorOptions.showClearButton = true;
        }
    }




    onSavingOnTable(source: string , e) {
        console.log('Saving: ', e);

        const s: FeeScheduleDocFeeModel[] = [];

        e.changes.forEach(a => {
            s.push( {

                DocFeeScheduleItemID:  a.type === 'insert' ?   this.firstRow_DocFeeScheduleItemID : a.key,

                enumFeeItemCategoryId : a.data?.enumFeeItemCategoryId ?? '',
                Code : a.data?.Code ?? '',
                Fee : a.data?.Fee ?? -1,
                rtype : source === 'grid' ?  a.type :  't-' + a.type,
                Description: a.data?.Description ?? '',
                ParentFeeScheduleItemID: a.data?.ParentFeeScheduleItemID ?? ''
            });
        });


        this.feeScheduleService.postDocFeeScheduleItemsV2(s).subscribe( res => {
            this.toastr.success(res, 'Fees Saved', { enableHtml: true, timeOut: 5000 });

            this.loadFeeScheduleData();
        });
    }


    treeGridTitle: string = '';
    onSelectionChangedTree(e: any) {
        this.treeItemSelected = e.selectedRowsData[0];
        this.listOfFees_TableTreeFiltered = [];

        this.treeGridTitle = this.treeItemSelected.Description;
        if ( this.treeItemSelected.FeeScheduleItems  )  {
            if (this.treeItemSelected.FeeScheduleItems.length == 0)  {
                this.listOfFees_TableTreeFiltered = this.listOfFees_Table.filter(f => f.ParentFeeScheduleItemID == this.treeItemSelected.FeeScheduleItemID);
                this.gridContainerTree.instance.refresh();
            }
        }
    }


    onFeeViewItemClick(e) {

        this.currentFeeView = e.itemData.name;
    }

    onImportClick() {

      if(this.listOfFees_Table.length===0) {
         this.toastr.info('Please load a Fee Schedule !', 'Missing Info', { enableHtml: true, timeOut: 5000 });
         return;
      }
        // FeeScheduleImportCvsComponent
        const dialogZRef = this.dialog.open( FeeScheduleImportCvsComponent  , {

            data: {
                DocFeeScheduleID: this.feeScheduleDoctor.DocFeeScheduleID
            }
        });
        dialogZRef.afterClosed().subscribe(result => {
            if (result == 'OK') {


             this.loadFeeScheduleData();
            }
        });





    }

    onPriceAjustClick() {


        const dialogRef = this.dialog.open(FeeAdjustmentsComponent, {
            panelClass: 'dialog',
            data: {
                DocFeeScheduleID: this.selectedDocFeeScheduleID
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == 'OK') {

                this.loadFeeScheduleData();
            }
        });



    }

    onNewCodeClick()  {
        this.toastr.success('This feature is not implemented yet', 'Not Implemented', { enableHtml: true, timeOut: 5000 });

        // code name, description , cat, amount
        // select hiearchy / parent
        // add to master (so all new Feesedules will have it )
        // add to all fee schedules

    }





}
